import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface CommentairePictoProps extends pictoProps {
}

export interface CommentairePictoState extends pictoState {
}

export class CommentairePicto extends Picto<CommentairePictoProps,CommentairePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.commentairePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(CommentairePicto);
